<template lang="pug">
  #Detalle
    Header

    //- ── Breadcrumb ─────────────────────────────────────────────────────────
    div.breadcrumb-bar
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='11')
            div.breadcrumb-inner
              a.bread-link(href='/') Inicio
              span.bread-sep /
              a.bread-link(href='/productos') Productos
              span.bread-sep /
              span.bread-current(v-if='producto') {{producto.art_des}}

    //- ── Barra departamentos ────────────────────────────────────────────────
    div.depart-bar
      v-container(fluid)
        v-skeleton-loader.mx-auto#ld6(v-if='policeDepart' style='width:100%;' type='image')
        div(v-if='departamentos && departamentos.length > 0')
          carousel(:perPageCustom="[[320, 2],[480, 3], [768, 5], [1160, 9]]")
            slide(v-for='(item,i) in departamentos' :key='i' style='padding: 0 6px;text-align:center;')
              div.depart-item(@click='irProductos(item)')
                div.depart-icon-wrap
                  img(:src='ruta + item.imagen' class='depart-icon')
                span.depart-name {{item.lin_des}}

    //- ── Contenido principal ────────────────────────────────────────────────
    div.detalle-main
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='12' sm='11' md='11')

            //- Skeleton
            v-row(v-if='policeProd')
              v-col(cols='12' md='5')
                v-skeleton-loader.mx-auto#ld7(style='width:100%;' type='image')
              v-col(cols='12' md='7')
                v-skeleton-loader#ld8(style='width:100%;' type='image')
                v-skeleton-loader#ld8(style='width:60%;margin-top:12px;' type='image')
                v-skeleton-loader#ld8(style='width:50%;margin-top:12px;' type='image')
                v-skeleton-loader#ld9(style='width:100%;margin-top:20px;' type='image')

            //- Producto
            v-row(v-if='producto')

              //- ── Columna imágenes ───────────────────────────────────────
              v-col(cols='12' md='5')
                div.img-panel

                  //- Toast añadido al carrito
                  div.cart-toast(v-if='mostrarMensaje')
                    v-icon(color='white' small) mdi-check-circle
                    span Producto añadido al carrito

                  //- Imagen principal
                  div.img-main
                    img(v-if='producto.imagen && producto.imagen.length > 0' :src='ruta + seleccion.url' class='img-principal')
                    img(v-else src='@/assets/imgFerco/image.png' class='img-principal')

                  //- Thumbnails
                  div.img-thumbs(v-if='producto.imagen && producto.imagen.length > 1')
                    div(
                      v-for='(img, i) in producto.imagen'
                      :key='i'
                      @click='seleccionarImg(img, i)'
                      :class="['thumb', { active: index == i }]"
                    )
                      img(:src='ruta + img.url' class='thumb-img')

              //- ── Columna info ───────────────────────────────────────────
              v-col(cols='12' md='7')
                div.info-panel

                  //- Marca + código
                  div.info-top
                    span.info-marca {{producto.marcaN}}
                    span.info-codigo {{producto.co_art}}

                  //- Nombre
                  h1.info-nombre {{producto.art_des}}

                  //- Meta
                  div.info-meta
                    div.meta-row(v-if='producto.ref')
                      span.meta-label Ref:
                      span.meta-val {{producto.ref}}
                    div.meta-row(v-if='producto.modelo')
                      span.meta-label Modelo:
                      span.meta-val {{producto.modelo}}
                    div.meta-row(v-if='producto.campo4')
                      span.meta-label Política de venta:
                      span.meta-val {{producto.campo4}}
                    div.meta-row(v-if='producto.categoriaN')
                      span.meta-label Categoría:
                      span.meta-val {{producto.categoriaN}}

                  //- Stock
                  div.info-stock(v-if='mostrarS')
                    div.stock-ok(v-if='disponibilidad(producto, producto.unidad) > 0')
                      v-icon(small color='#38a169') mdi-check-circle
                      span En stock ({{disponibilidad(producto, producto.unidad)}})
                    div.stock-no(v-else)
                      v-icon(small color='#e53e3e') mdi-close-circle
                      span Sin stock

                  //- Descripción
                  p.info-desc(v-if='producto.descripcion') {{producto.descripcion}}

                  //- Precio
                  div.info-precio-wrap(v-if='mostrarP')
                    div.info-precio ${{ (producto.equivalente > 1) ? (producto.precio / producto.equivalente).toFixed(2) : producto.precio }}
                      span.info-precio-label(v-if='producto.equivalente > 1')  / unidad
                    div.info-precio-paq(v-if='producto.equivalente > 1') Paquete: ${{producto.precio}} × {{producto.equivalente}} unidades

                  v-divider.my-4

                  //- Presentaciones
                  div(v-if='(producto.presentacion1 && producto.presentacion1.id) || (producto.presentacion2 && producto.presentacion2.id)')
                    div.pres-group(v-if='producto.presentacion1 && producto.presentacion1.id')
                      div.pres-title {{producto.presentacion1.id.titulo}}
                      div.pres-options
                        div(
                          v-for='item in presentaciones1'
                          :key='item.valor'
                          @click='seleccionarPre(item)'
                          :class="['pres-option', { active: producto.presentacion1.valor == item.valor }]"
                        )
                          span {{item.valor}}
                          span.pres-stock(v-if='item.stock && item.stock > 0') {{item.stock}}
                          span.pres-sin(v-else) Sin stock
                    div.pres-group(v-if='producto.presentacion2 && producto.presentacion2.id' style='margin-top:20px;')
                      div.pres-title {{producto.presentacion2.id.titulo}}
                      div.pres-options
                        div(
                          v-for='item in presentaciones2'
                          :key='item.valor'
                          @click='seleccionarPre(item)'
                          :class="['pres-option', { active: producto.presentacion2.valor == item.valor }]"
                        )
                          span {{item.valor}}
                          span.pres-stock(v-if='item.stock && item.stock > 0') {{item.stock}}
                          span.pres-sin(v-else) Sin stock

                  //- Sin stock banner
                  div.sin-stock-banner(v-if='!producto.stock || producto.stock <= 0')
                    v-icon(color='white') mdi-alert-circle-outline
                    span Sin stock disponible

                  //- Agregar al carrito
                  div.add-cart-row(v-if='producto.stock && producto.stock > 0')
                    div.qty-control#inpp
                      v-btn(@click='restar()' class='qty-btn').elevation-0
                        v-icon mdi-minus
                      div.qty-divider
                      v-text-field(v-model='cantidad' type='number' min='1' :max='producto.stock' hide-details='' outlined='' dense='' :hide-spin-buttons='true' readonly='' class='qty-input').elevation-0
                      div.qty-divider
                      v-btn(@click='sumar()' class='qty-btn').elevation-0
                        v-icon mdi-plus
                    v-btn(@click='añadircarrito()' class='btn-add-cart').elevation-0
                      v-icon(left small) mdi-cart-plus
                      | Agregar al carrito

    //- ── Productos similares ────────────────────────────────────────────────
    div.similares-section(v-if='similares && similares.length > 0')
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='12' sm='11' md='11')
            h2.similares-title Productos similares

            //- Grid similares
            div.similares-grid
              div.sim-card(v-for='(item, index) in similares' :key='index' @click='ir(item._id)')
                div.sim-img-wrap
                  img(v-if='item.imagen && item.imagen[0]' :src='ruta + item.imagen[0].url' class='sim-img')
                  img(v-else src='@/assets/imgFerco/image.png' class='sim-img')
                div.sim-info
                  span.sim-name {{item.art_des}}
                  span.sim-marca {{item.marcaN}}
                  div.sim-bottom
                    span.sim-stock(v-if='mostrarS && item.stock && item.stock > 0') Stock: {{item.stock}}
                    span.sim-sin(v-if='mostrarS && (!item.stock || item.stock <= 0)') Sin stock
                    span.sim-precio(v-if='mostrarP') ${{item.precio}}
                v-icon.sim-arrow mdi-chevron-right

    Footer
</template>

<script>
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'
import Api from '@/services/methods'
import { EventBus } from '../Events.js'
import { serverImg } from '@/services/environment'
export default {
  name: 'Detalle',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      arraySke: ['1', '2', '3', '4', '5', '6', '7', '8'],
      arrayPro: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      policeDepart: true,
      policeProd: true,
      seleccion: null,
      index: null,
      mostrarMensaje: false,
      departamentos: [],
      presentaciones1: [],
      presentaciones2: [],
      producto: null,
      ruta: serverImg,
      mostrarP: false,
      mostrarS: false,
      cantidad: 0,
      similares: [],
      grupos: [],
      car: []
    }
  },
  watch: {
    cantidad (val) {
      if (!this.producto) return
      const num = parseFloat(val)
      if (isNaN(num) || num < 0) {
        this.$nextTick(() => { this.cantidad = 0 })
        return
      }
      const equi = parseFloat(this.producto.equivalente) || 1
      const stockMax = Math.trunc(this.disponibilidad(this.producto, this.producto.unidad))
      // Limitar al stock máximo
      if (num > stockMax) {
        this.$nextTick(() => { this.cantidad = stockMax - (stockMax % equi) })
        return
      }
      // Redondear al múltiplo de equivalente más cercano (hacia abajo)
      if (equi > 1 && num % equi !== 0) {
        this.$nextTick(() => { this.cantidad = Math.floor(num / equi) * equi })
      }
    }
  },
  mounted () {
    EventBus.$on('buscarDetalle', async data => {
      this.policeProd = true
      await this.obtenerProducto(data)
    })
  },
  async created () {
    if (this.$store.state.fercoWeb && this.$store.state.fercoWeb.co_cli) {
      this.mostrarP = true
    }
    if (this.$store.state.fercoWeb && this.$store.state.fercoWeb.stock) {
      this.mostrarS = this.$store.state.fercoWeb.stock
    }
    if (this.$store.state.carFerco !== null) {
      this.car = this.$store.state.carFerco
    }
    if (this.$route.params && this.$route.params.value) this.producto = this.$route.params.value
    document.documentElement.scrollTop = 0
    await this.initialize()
  },
  methods: {
    ir (item) {
      this.$router.push('/detalle/' + item)
      this.obtenerProducto(item)
      document.documentElement.scrollTop = 0
    },
    seleccionarImg (img, i) {
      this.seleccion = img
      this.index = i
    },
    showAlert () {
      Swal.fire({
        position: 'top-start',
        icon: 'error',
        title: 'Ha superado el limite de productos con respecto a la existencia del mismo.',
        showConfirmButton: false,
        timer: 1500
      })
    },
    validarCrdito () {
      let tot = 0
      this.car.forEach(el => {
        tot += parseFloat(el.cant) * parseFloat(el.precio)
      })
      console.log(tot)
      if (tot > parseFloat(this.$store.state.fercoWeb.mont_cre)) {
        this.$swal.fire({
          position: 'top-end',
          icon: 'info',
          title: 'Estimado cliente, ha sobrepasado el límite de crédito',
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    añadircarrito () {
      if (this.cantidad > 0) {
        const equi = parseFloat(this.producto.equivalente) || 1
        if (equi > 1 && this.cantidad % equi !== 0) {
          this.$swal.fire({ position: 'top-end', icon: 'warning', title: `La cantidad debe ser múltiplo de ${equi}`, showConfirmButton: false, timer: 2000 })
          this.cantidad = Math.floor(this.cantidad / equi) * equi
          return
        }
        // this.validarCrdito()
        if (this.car && this.car.length >= 25) {
          this.$swal.fire({
            position: 'top-end',
            icon: 'info',
            title: 'Estimado cliente, ha sobrepasado el límite de productos por pedido.',
            showConfirmButton: false,
            timer: 1500
          })
        } else {
          let check = false
          const info = {
            ...this.producto,
            cant: this.cantidad
          }
          for (let i = 0; i < this.car.length; i++) {
            if (info._id === this.car[i]._id) {
              if ((parseInt(this.car[i].cant) + info.cant) > parseInt(this.car[i].stock)) {
                check = true
                this.showAlert()
              } else {
                this.$store.dispatch('agregarcarrito2', info)
                EventBus.$emit('actCarrito')
                check = true
                this.mostrarMensaje = true
                setTimeout(function () { this.mostrarMensaje = false }.bind(this), 3000)
                this.cantidad = 0
                this.car = this.$store.state.carFerco
              }
            }
          }
          if (check === false) {
            this.$store.dispatch('agregarcarrito', info)
            EventBus.$emit('actCarrito')
            this.car = this.$store.state.carFerco
            this.mostrarMensaje = true
            setTimeout(function () { this.mostrarMensaje = false }.bind(this), 3000)
            this.cantidad = 0
          }
        }
      } else {
        this.$swal.fire({
          position: 'top-start',
          icon: 'error',
          title: 'La cantidad debe ser mayor a 0 para poder añadirlo al carrito.',
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    disponibilidad (item, unidad) {
      let equi
      for (let i = 0; i < item.unidades.length; i++) {
        if (unidad === item.unidades[i]) {
          equi = i
        }
      }
      if (equi === 0) {
        return item.stock
      } else {
        return Math.round(item.stock * item.equivalencia[equi])
      }
    },
    sumar () {
      if (this.cantidad) {
        const vald = parseFloat(this.cantidad) + parseFloat(this.producto.equivalente)
        if (vald <= Math.trunc(this.disponibilidad(this.producto, this.producto.unidad))) {
          this.cantidad = parseFloat(this.cantidad) + parseFloat(this.producto.equivalente)
        }
      } else {
        const vald = parseFloat(this.cantidad) + parseFloat(this.producto.equivalente)
        if (vald <= Math.trunc(this.disponibilidad(this.producto, this.producto.unidad))) {
          this.cantidad = parseFloat(this.producto.equivalente)
        } else {
          this.$swal.fire({
            position: 'top-start',
            icon: 'error',
            title: 'Este producto no esta disponible en esta unidad',
            showConfirmButton: false,
            timer: 1500
          })
        }
      }
      // if ((this.cantidad+1) > parseFloat(this.producto.stock)) {
      //   this.cantidad = parseFloat(this.producto.stock)
      // } else this.cantidad++
    },
    restar () {
      if (this.cantidad) {
        const vald = parseFloat(this.cantidad) - parseFloat(this.producto.equivalente)
        if (vald >= 0) {
          this.cantidad = parseFloat(this.cantidad) - parseFloat(this.producto.equivalente)
        }
      } else {
        this.cantidad = 0
      }
      // if ((this.cantidad-1) < 1) {
      //   this.cantidad = 1
      // } else this.cantidad--
    },
    irProductos (item) {
      this.$router.push({ name: 'Productos', params: { depart: item } })
    },
    async seleccionarPre (item) {
      // let id
      // for (let i = 0; i < this.grupos.length; i++) {
      //   const el = this.grupos[i];
      //   if (el.presentacion1 && el.presentacion1.id && el.presentacion1.id == item.id && el.presentacion1.valor == item.valor) id = el._id
      //   if (el.presentacion2 && el.presentacion2.id && el.presentacion2.id == item.id && el.presentacion2.valor == item.valor) id = el._id
      // }
      // await this.obtenerProducto(id)
      for (let i = 0; i < this.grupos.length; i++) {
        const el = this.grupos[i]
        if (el.presentacion1 && el.presentacion1.id && el.presentacion1.id == item.id && el.presentacion1.valor == item.valor) this.producto = el
        if (el.presentacion2 && el.presentacion2.id && el.presentacion2.id == item.id && el.presentacion2.valor == item.valor) this.producto = el
      }
      if (this.producto.imagen && this.producto.imagen[0]) {
        this.seleccion = this.producto.imagen[0]
        this.index = 0
      }
    },
    obtenerProducto (code) {
      const cli = (this.$store.state.fercoWeb && this.$store.state.fercoWeb.co_precio) ? this.$store.state.fercoWeb.co_precio.trim() : null
      Api.get('productosCom/detailWeb?id=' + code + '&codigo=' + cli).then(res => {
        this.policeProd = false
        this.producto = res.data.producto
        this.producto.unidad = (res.data.producto.unidades[1]) ? res.data.producto.unidades[1] : res.data.producto.unidades[0],
        this.producto.equivalente = (res.data.producto.equivalencia[1]) ? res.data.producto.equivalencia[1] : res.data.producto.equivalencia[0],
        this.similares = res.data.similares
        this.grupos = res.data.grupos
        this.presentaciones1 = []
        this.presentaciones2 = []
        if (this.producto.presentacion1 && this.producto.presentacion1.id) this.presentaciones1.push({ id: this.producto.presentacion1.id._id, valor: this.producto.presentacion1.valor, stock: this.producto.stock })
        if (this.producto.presentacion2 && this.producto.presentacion2.id) this.presentaciones2.push({ id: this.producto.presentacion2.id._id, valor: this.producto.presentacion2.valor, stock: this.producto.stock })
        if (this.grupos && this.grupos.length > 0) {
          for (let i = 0; i < this.grupos.length; i++) {
            const el = this.grupos[i]
            if (this.producto.presentacion1 && this.producto.presentacion1.id) {
              if (el.presentacion1 && el.presentacion1.id && el.presentacion1.id == this.producto.presentacion1.id._id) {
                let bool = false
                for (let j = 0; j < this.presentaciones1.length; j++) {
                  const el2 = this.presentaciones1[j]
                  if (el.presentacion1.valor == el2.valor) bool = true
                }
                if (!bool) this.presentaciones1.push({ id: el.presentacion1.id, valor: el.presentacion1.valor, stock: el.stock })
              }
            }
            if (this.producto.presentacion2 && this.producto.presentacion2.id) {
              if (el.presentacion2 && el.presentacion2.id && el.presentacion2.id == this.producto.presentacion2.id._id) {
                let bool = false
                for (let j = 0; j < this.presentaciones2.length; j++) {
                  const el2 = this.presentaciones2[j]
                  if (el.presentacion2.valor == el2.valor) bool = true
                }
                if (!bool) this.presentaciones2.push({ id: el.presentacion2.id, valor: el.presentacion2.valor, stock: el.stock })
              }
            }
          }
        }
        if (this.presentaciones1.length > 0) this.presentaciones1.sort(function (a, b) { return a.valor - b.valor })
        if (this.presentaciones2.length > 0) this.presentaciones2.sort(function (a, b) { return a.valor - b.valor })
        if (this.producto.imagen && this.producto.imagen[0]) {
          this.seleccion = this.producto.imagen[0]
          this.index = 0
        }
      })
    },
    async initialize () {
      this.policeDepart = true
      this.policeProd = true
      Api.get('departamentos/withImg').then(res => {
        this.departamentos = res.data
        this.policeDepart = false
      })
      const arry = this.$route.path.split('/')
      await this.obtenerProducto(arry[2])
    }
  }
}
</script>
<style lang="scss">
@import "~@/assets/scss/productos.scss";
@import "~@/assets/scss/detalle.scss";
</style>
